import React from "react"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-intl"

import H from "components/atoms/H"
import P from "components/atoms/P"
import Project from "../Project"
import Form from "../Form"

import {
  StyledWrapper,
  StyledProjecsWrapper,
  StyledProjectList,
  StyledSubscriptionFormWrapper,
  selectedTitleStyles,
} from "./ConfirmationStep.styles"

const ConfirmationStep = ({ selectedProjects, sendForm }) => {
  const { formatMessage } = useIntl()

  return (
    <>
      <StyledWrapper data-testid="subscribeConfirmationStepWrapper">
        <StyledProjecsWrapper>
          <H
            as="h3"
            extraStyles={selectedTitleStyles}
            data-testid="subscribeConfirmationStepTitle"
          >
            {formatMessage({
              id: "subscriptionModal.confirmationStep.title",
            })}
          </H>
          <StyledProjectList data-testid="subscribeConfirmationStepProjectList">
            {selectedProjects.map((project) => (
              <Project
                project={project}
                key={project.id}
                isSelected={project.selected}
              />
            ))}
          </StyledProjectList>
        </StyledProjecsWrapper>
        <StyledSubscriptionFormWrapper data-testid="subscribeConfirmationStepFormWrapper">
          <H as="h3" data-testid="subscribeConfirmationStepFormTitle">
            {formatMessage({
              id: "subscriptionModal.confirmationStep.confirm",
            })}
          </H>
          <Form sendForm={sendForm} />
          <P data-testid="subscribeConfirmationStepFormPolicy">
            {formatMessage({
              id: "subscriptionModal.confirmationStep.policy",
            })}
          </P>
        </StyledSubscriptionFormWrapper>
      </StyledWrapper>
    </>
  )
}

ConfirmationStep.propTypes = {
  selectedProjects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      selected: PropTypes.bool,
      overview: PropTypes.shape({
        city: PropTypes.shape({
          name: PropTypes.string,
          stateCode: PropTypes.string,
        }),
      }),
      bannerImages: PropTypes.arrayOf(
        PropTypes.shape({
          image: PropTypes.oneOfType([
            PropTypes.shape({
              original: PropTypes.string,
              large: PropTypes.string,
              medium: PropTypes.string,
              small: PropTypes.string,
            }),
            PropTypes.string,
          ]),
          id: PropTypes.string,
        })
      ),
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  sendForm: PropTypes.func.isRequired,
}
export default ConfirmationStep
